import React from 'react';
import {getAssetPath} from "../../../utils/get-asset-path.js";

const PrintFooter = ({className}) => {
    return (
        <footer id="footer" className={[className, "mt-3 text-xs"].join(" ")}>
            <div className="border-t border-gray-200 mt-4 mb-2"/>

            <div className="flex justify-between items-center mb-6 print:!px-[25px]">
                <div className="flex items-center">
                    <img src={getAssetPath("img/sentry-logo-blue.svg")}
                         className="h-[8.5mm] w-auto inline-block mr-1" alt="Logo Sentry"/>
                </div>
                <span>
                  {(() => {
                      const d = new Date();
                      const date = d.toLocaleDateString("pt-BR");
                      const hour = d.toLocaleTimeString("pt-BR", {
                          hour: "2-digit",
                          minute: "2-digit"
                      });

                      return `Impresso em ${date} às ${hour}`;
                  })()}
             </span>
            </div>
        </footer>
    );
};

export default PrintFooter;